import React, { useEffect, useState } from 'react';

import { head, includes } from 'lodash';
import PropTypes from 'prop-types';

import { ButtonComponent } from 'components/ButtonComponent/ButtonComponent';

import SelectImageWithPagination from './SelectImageWithPagination';

import { Dialog, DialogActions } from '../style';

export function SelectImage({ open, handleClose, selectedImage, setImage, title, getPictures, withDelete, text }) {
  const [images, setImages] = useState([]);
  const [selectedImagesIds, setSelectedImagesIds] = useState([]);

  useEffect(() => {
    if (selectedImage) {
      setSelectedImagesIds([selectedImage.id]);
    } else {
      setSelectedImagesIds([]);
    }
  }, [selectedImage, open]);

  const handleSave = () => {
    setImage(images.find(image => image.id === head(selectedImagesIds)));
    handleClose();
  };

  const onChangeSelected = id =>
    withDelete && includes(selectedImagesIds, id) ? setSelectedImagesIds([]) : setSelectedImagesIds([id]);

  return (
    <Dialog fullWidth open={open} onClose={handleClose} className="large">
      <SelectImageWithPagination
        setImage={setImage}
        title={title}
        text={text}
        getPictures={getPictures}
        images={images}
        setImages={setImages}
        selectedImagesIds={selectedImagesIds}
        onChangeSelected={onChangeSelected}
      />
      <DialogActions>
        <ButtonComponent text="Cancel" onClick={handleClose} />
        <ButtonComponent text="Save" color="primary" onClick={handleSave} />
      </DialogActions>
    </Dialog>
  );
}

SelectImage.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  selectedImage: PropTypes.shape({ id: PropTypes.number }),
  setImage: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  getPictures: PropTypes.func.isRequired,
  withDelete: PropTypes.bool,
  text: PropTypes.string,
};

SelectImage.defaultProps = {
  selectedImage: null,
  withDelete: false,
  text: '',
};
